import React, { useEffect, useState } from "react";
import { SummaryCard } from "../AVPForms/components/StyledComponent";

const MigratedSummary = ({ id }) => {
  const [applicationData, setApplicationData] = useState(null);

  async function fetchMigratedData() {
    try {
      const response = await Digit.OBPSService.BPAmigratedSearchappNo({ applicationNo: id });
      console.log(response, "migratedData"); // Logs the resolved data
      setApplicationData(response?.Application);
    } catch (error) {
      console.error("Error fetching migrated data:", error);
    }
  }

  useEffect(() => {
    fetchMigratedData();
  }, [id]);
  console.log(applicationData, "applicationData");
  const {applicationChecklist,  projectDetail, architectDetail, ownerDetail, plotDetail, challanHeads, challans, sanctionFiles, documents } = applicationData || {};

  return (
    <div className="groupContainer" style={{ width: "100%", marginTop: "1rem" }}>
      <SummaryCard className="formContainer">
        <div className="formHeaderContainer">
          <h2 className="formHeading">File Detail</h2>
        </div>
        <div className="formInputContainer" style={{ display: "flex", justifyContent: "center" }}>
          <div style={{ width: "100%" }}>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <tbody>
                <tr>
                  <td style={{ width: "25%", textAlign: "left", padding: "8px" }}>
                    <b>File No:</b>
                  </td>
                  <td style={{ width: "25%", padding: "8px" }}>{projectDetail?.applicationNumber}</td>
                  <td style={{ width: "25%", textAlign: "left", padding: "8px" }}>
                    <b>Proposal Date:</b>
                  </td>
                  <td style={{ width: "25%", padding: "8px" }}>{projectDetail?.proposalDate}</td>
                </tr>

                <tr>
                  <td style={{ textAlign: "left", padding: "8px" }}>
                    <b>Nature Of Construction/Case Type:</b>
                  </td>
                  <td style={{ padding: "8px" }}>{projectDetail?.caseType}</td> 
                  <td style={{ textAlign: "left", padding: "8px" }}>
                    <b>Is Proposal Type Design(Plotted Development):</b>
                  </td>
                  <td style={{ padding: "8px" }}>{projectDetail?.plottedDevelopment}</td>
                </tr>

                <tr>
                  <td style={{ textAlign: "left", padding: "8px" }}>
                    <b>Is Revised:</b>
                  </td>
                  <td style={{ padding: "8px" }}>{projectDetail?.isRevised}</td>
                  <td style={{ textAlign: "left", padding: "8px" }}>
                    <b>Project Type:</b>
                  </td>
                  <td style={{ padding: "8px" }}>{projectDetail?.projectType}</td>
                </tr>

                <tr>
                  <td style={{ textAlign: "left", padding: "8px" }}>
                    <b>District:</b>
                  </td>
                  <td style={{ padding: "8px" }}>{projectDetail?.district}</td>
                  <td style={{ textAlign: "left", padding: "8px" }}>
                    <b>Tehsil:</b>
                  </td>
                  <td style={{ padding: "8px" }}>{projectDetail?.tehsil}</td>
                </tr>

                <tr>
                  <td style={{ textAlign: "left", padding: "8px" }}>
                    <b>Revenue Village:</b>
                  </td>
                  <td style={{ padding: "8px" }}>{projectDetail?.revenueVillage}</td>
                  <td style={{ textAlign: "left", padding: "8px" }}>
                    <b>Land Mark:</b>
                  </td>
                  <td style={{ padding: "8px" }}>{projectDetail?.landMark}</td>
                </tr>

                <tr>
                  <td style={{ textAlign: "left", padding: "8px" }}>
                    <b>Is this Special Project:</b>
                  </td>
                  <td style={{ padding: "8px" }}>{projectDetail?.isSpecialProject}</td>
                  <td style={{ textAlign: "left", padding: "8px" }}>
                    <b>Special Project:</b>
                  </td>
                  <td style={{ padding: "8px" }}>{projectDetail?.specialProject}</td>
                </tr>
                <tr>
                  <td style={{ textAlign: "left", padding: "8px" }}>
                    <b>Is proposal transit oriented developemnt:</b>
                  </td>
                  <td style={{ padding: "8px" }}>{projectDetail?.landUseUnderTOD}</td>
                  <td style={{ textAlign: "left", padding: "8px" }}>
                    <b>Converted Land Use Under TOD:</b>
                  </td>
                  <td style={{ padding: "8px" }}>{projectDetail?.tod}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </SummaryCard>

      <SummaryCard className="formContainer">
        <div className="formHeaderContainer">
          <h2 className="formHeading">Sanction Letter & Drawing</h2>
        </div>
        <div className="formInputContainer" style={{ display: "flex", justifyContent: "center" }}>
          <div style={{ width: "100%" }}>
            <table style={{ width: "100%", borderCollapse: "collapse", textAlign: "left" }}>
              <thead>
               
              </thead>
              <tbody>
                {sanctionFiles?.length > 0 && (
                  <tr>
                    <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}>
                      <b>Sanction Letter</b>
                    </td>
                    <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}>
                      <a
                        href={sanctionFiles[1]?.fileStoreURL}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: "blue", textDecoration: "underline" }}
                      >
                        Click Here
                      </a>
                    </td>
                  </tr>
                )}
                {sanctionFiles?.length > 1 && (
                  <tr>
                    <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}>
                      <b>Drawing</b>
                    </td>
                    <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}>
                      <a
                        href={sanctionFiles[0]?.fileStoreURL}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: "blue", textDecoration: "underline" }}
                      >
                        Click Here
                      </a>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </SummaryCard>

      {/* Owner Info */}
      <SummaryCard className="formContainer">
        <div className="formHeaderContainer">
          <h2 className="formHeading">Owner Detail</h2>
        </div>
        <div className="formInputContainer" style={{ display: "flex", justifyContent: "center" }}>
          <div style={{ width: "100%" }}>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <tbody>
                <tr>
                  <td style={{ width: "25%", textAlign: "left", padding: "8px" }}>
                    <b>Owner's Name:</b>
                  </td>
                  <td style={{ width: "25%", padding: "8px" }}>{ownerDetail?.ownerName}</td>
                  <td style={{ width: "25%", textAlign: "left", padding: "8px" }}>
                    <b>Owner's Contact No:</b>
                  </td>
                  <td style={{ width: "25%", padding: "8px" }}>{ownerDetail?.ownerContactNo}</td>
                </tr>

                <tr>
                  <td style={{ textAlign: "left", padding: "8px" }}>
                    <b>Owner Email:</b>
                  </td>
                  <td style={{ padding: "8px" }}>{ownerDetail?.ownerEmail}</td>
                  <td style={{ textAlign: "left", padding: "8px" }}>
                    <b>State:</b>
                  </td>
                  <td style={{ padding: "8px" }}>{ownerDetail?.state}</td>
                </tr>

                <tr>
                  <td style={{ textAlign: "left", padding: "8px" }}>
                    <b>Address Line 1:</b>
                  </td>
                  <td style={{ padding: "8px" }} colSpan="3">
                    {ownerDetail?.addressLine1}
                  </td>
                </tr>

                <tr>
                  <td style={{ textAlign: "left", padding: "8px" }}>
                    <b>Pincode:</b>
                  </td>
                  <td style={{ padding: "8px" }}>{ownerDetail?.pincode || "N/A"}</td>
                  <td style={{ textAlign: "left", padding: "8px" }}>
                    <b>Site Address:</b>
                  </td>
                  <td style={{ padding: "8px" }}>{ownerDetail?.siteAdress}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </SummaryCard>

      <SummaryCard className="formContainer">
        <div className="formHeaderContainer">
          <h2 className="formHeading">Architect Detail</h2>
        </div>
        <div className="formInputContainer" style={{ display: "flex", justifyContent: "center" }}>
          <div style={{ width: "100%" }}>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <tbody>
                <tr>
                  <td style={{ width: "25%", textAlign: "left", padding: "8px" }}>
                    <b>Architect's Name:</b>
                  </td>
                  <td style={{ width: "25%", padding: "8px" }}>{architectDetail?.architectName}</td>
                  <td style={{ width: "25%", textAlign: "left", padding: "8px" }}>
                    <b>Consultant Category:</b>
                  </td>
                  <td style={{ width: "25%", padding: "8px" }}>{architectDetail?.consultantCategory}</td>
                </tr>

                <tr>
                  <td style={{ textAlign: "left", padding: "8px" }}>
                    <b>COA/License No:</b>
                  </td>
                  <td style={{ padding: "8px" }}>{architectDetail?.licenseNo}</td>
                  <td style={{ textAlign: "left", padding: "8px" }}>
                    <b>Validity Upto:</b>
                  </td>
                  <td style={{ padding: "8px" }}>{architectDetail?.validityUpto}</td>
                </tr>

                <tr>
                  <td style={{ textAlign: "left", padding: "8px" }}>
                    <b>Mobile Number:</b>
                  </td>
                  <td style={{ padding: "8px" }}>{architectDetail?.mobileNumber}</td>
                  <td style={{ textAlign: "left", padding: "8px" }}>
                    <b>Email ID:</b>
                  </td>
                  <td style={{ padding: "8px" }}>{architectDetail?.emailId}</td>
                </tr>

                <tr>
                  <td style={{ textAlign: "left", padding: "8px" }}>
                    <b>Login Name:</b>
                  </td>
                  <td style={{ padding: "8px" }}>{architectDetail?.loginName}</td>
                  <td style={{ textAlign: "left", padding: "8px" }}>
                    <b>Address:</b>
                  </td>
                  <td style={{ padding: "8px" }}>{architectDetail?.address || "N/A"}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </SummaryCard>
      {applicationChecklist && <SummaryCard className="formContainer">
        <div className="formHeaderContainer">
          <h2 className="formHeading">Applicaion Checklist</h2>
        </div>
        {applicationChecklist?.reduce((rows, item, index) => {
            // Create a new row for every 2 items
            if (index % 2 === 0) {
              rows.push(
                <tr key={`row-${index}`}>
                  <td style={{ textAlign: "left", padding: "8px" }}>
                    <b>{applicationChecklist[index]?.caption}:</b>
                  </td>
                  <td style={{ padding: "8px" }}>{applicationChecklist[index]?.value}</td>
                  {applicationChecklist[index + 1] && (
                    <React.Fragment key={`row-${index + 1}`}>
                      <td style={{ textAlign: "left", padding: "8px" }}>
                        <b>{applicationChecklist[index + 1]?.caption}:</b>
                      </td>
                      <td style={{ padding: "8px" }}>{applicationChecklist[index + 1]?.value}</td>
                    </React.Fragment>
                  )}
                </tr>
              );
            }
            return rows;
          }, [])}
      </SummaryCard>}
      <SummaryCard className="formContainer">
        <div className="formHeaderContainer">
          <h2 className="formHeading">Plot Detail</h2>
        </div>
        <div className="formInputContainer" style={{ display: "flex", justifyContent: "center" }}>
          <div style={{ width: "100%" }}>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <tbody>
                <tr>
                  <td style={{ width: "25%", textAlign: "left", padding: "8px" }}>
                    <b>Land Use Zone:</b>
                  </td>
                  <td style={{ width: "25%", padding: "8px" }}>{plotDetail?.landUseZone}</td>
                  <td style={{ width: "25%", textAlign: "left", padding: "8px" }}>
                    <b>Land Sub Use Zone:</b>
                  </td>
                  <td style={{ width: "25%", padding: "8px" }}>{plotDetail?.landSubUseZone}</td>
                </tr>

                <tr>
                  <td style={{ textAlign: "left", padding: "8px" }}>
                    <b>Plot Use:</b>
                  </td>
                  <td style={{ padding: "8px" }}>{plotDetail?.plotUse}</td>
                  <td style={{ textAlign: "left", padding: "8px" }}>
                    <b>Plot Sub Use:</b>
                  </td>
                  <td style={{ padding: "8px" }}>{plotDetail?.plotSubUse}</td>
                </tr>

                <tr>
                  <td style={{ textAlign: "left", padding: "8px" }}>
                    <b>Development Area:</b>
                  </td>
                  <td style={{ padding: "8px" }}>{plotDetail?.developmentArea}</td>
                  <td style={{ textAlign: "left", padding: "8px" }}>
                    <b>Sub Development Area:</b>
                  </td>
                  <td style={{ padding: "8px" }}>{plotDetail?.subdevelopmentArea || "N/A"}</td>
                </tr>

                <tr>
                  <td style={{ textAlign: "left", padding: "8px" }}>
                    <b>Plan On:</b>
                  </td>
                  <td style={{ padding: "8px" }}>{plotDetail?.planOn}</td>
                  <td style={{ textAlign: "left", padding: "8px" }}>
                    <b>Scheme:</b>
                  </td>
                  <td style={{ padding: "8px" }}>{plotDetail?.scheme}</td>
                </tr>

                <tr>
                  <td style={{ textAlign: "left", padding: "8px" }}>
                    <b>Gata / Arazi No:</b>
                  </td>
                  <td style={{ padding: "8px" }}>{plotDetail?.araziNo}</td>
                  <td style={{ textAlign: "left", padding: "8px" }}>
                    <b>Max Building Height:</b>
                  </td>
                  <td style={{ padding: "8px" }}>{plotDetail?.maxBuildingHeight}m</td>
                </tr>

                <tr>
                  <td style={{ textAlign: "left", padding: "8px" }}>
                    <b>Plot Area:</b>
                  </td>
                  <td style={{ padding: "8px" }}>{plotDetail?.plotArea} sq.m</td>
                  <td style={{ textAlign: "left", padding: "8px" }}>
                    <b>Plot Area as per Document:</b>
                  </td>
                  <td style={{ padding: "8px" }}>{plotDetail?.plotAreaAsDocument || "N/A"}</td>
                </tr>

                <tr>
                  <td style={{ textAlign: "left", padding: "8px" }}>
                    <b>Total Builtup Area (sq.m):</b>
                  </td>
                  <td style={{ padding: "8px" }}>{plotDetail?.totalBUA} sq.m</td>
                  <td style={{ textAlign: "left", padding: "8px" }}>
                    <b>Existing Builtup Area(sq.m):</b>
                  </td>
                  <td style={{ padding: "8px" }}>{plotDetail?.existingBUA} sq.m</td>
                </tr>

                <tr>
                  <td style={{ textAlign: "left", padding: "8px" }}>
                    <b>Proposed Carpet Area:</b>
                  </td>
                  <td style={{ padding: "8px" }}>{plotDetail?.proposedCarpetArea} sq.m</td>
                  <td style={{ textAlign: "left", padding: "8px" }}>
                    <b>Development Plan:</b>
                  </td>
                  <td style={{ padding: "8px" }}>{plotDetail?.developmentPlan || "N/A"}</td>
                </tr>

                <tr>
                  <td style={{ textAlign: "left", padding: "8px" }}>
                    <b>Estimated Cost:</b>
                  </td>
                  <td style={{ padding: "8px" }}>₹{plotDetail?.estimatedCost}</td>
                  <td style={{ textAlign: "left", padding: "8px" }}>
                    <b>Ground Coverage Area:</b>
                  </td>
                  <td style={{ padding: "8px" }}>{plotDetail?.groundCoverageArea} sq.m</td>
                </tr>

                <tr>
                  <td style={{ textAlign: "left", padding: "8px" }}>
                    <b>Community Parking:</b>
                  </td>
                  <td style={{ padding: "8px" }}>{plotDetail?.communityParking}</td>
                  <td style={{ textAlign: "left", padding: "8px" }}>
                    <b>Number of Stories:</b>
                  </td>
                  <td style={{ padding: "8px" }}>{plotDetail?.numberOfStories}</td>
                </tr>

                <tr>
                  <td style={{ textAlign: "left", padding: "8px" }}>
                    <b>Approved Layout:</b>
                  </td>
                  <td style={{ padding: "8px" }}>{plotDetail?.approvedLayout}</td>
                  <td style={{ textAlign: "left", padding: "8px" }}>
                    <b>Required Special Setback:</b>
                  </td>
                  <td style={{ padding: "8px" }}>{plotDetail?.requiredSepecialSetBack}</td>
                </tr>

                <tr>
                  <td style={{ textAlign: "left", padding: "8px" }}>
                    <b>Layout Sanction No:</b>
                  </td>
                  <td style={{ padding: "8px" }}>{plotDetail?.layoutSanctionNo || "N/A"}</td>
                  <td style={{ textAlign: "left", padding: "8px" }}>
                    <b>Layout Sanction Date:</b>
                  </td>
                  <td style={{ padding: "8px" }}>{plotDetail?.layoutSanctionDate || "N/A"}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </SummaryCard>

      <SummaryCard className="formContainer">
        <div className="formHeaderContainer">
          <h2 className="formHeading">Documents</h2>
        </div>
        <div className="formInputContainer" style={{ display: "flex", justifyContent: "center" }}>
          <div style={{ width: "100%" }}>
            <table style={{ width: "100%", borderCollapse: "collapse", textAlign: "left" }}>
              <thead>
                <tr>
                  <th style={{ padding: "8px", borderBottom: "1px solid #ddd" }}>Documents</th>
                </tr>
              </thead>
              <tbody>
                {documents?.map((doc) => (
                  <tr key={doc.fileId}>
                    <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}>{doc.docName}</td>
                    <a href={doc.fileStoreURL} target="_blank" rel="noopener noreferrer" style={{ color: "blue", textDecoration: "underline" }}>
                      Click here
                    </a>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </SummaryCard>

      <SummaryCard className="formContainer">
        <div className="formHeaderContainer">
          <h2 className="formHeading">Fee Challans</h2>
        </div>
        <div className="formInputContainer" style={{ display: "flex", justifyContent: "center" }}>
          <div style={{ width: "100%" }}>
            <table style={{ width: "100%", borderCollapse: "collapse", border: "1px solid #ddd" }}>
              <thead>
                <tr style={{ background: "#f5f5f5", textAlign: "left" }}>
                  <th style={{ padding: "8px", borderBottom: "1px solid #ddd" }}>Challan Number</th>
                  <th style={{ padding: "8px", borderBottom: "1px solid #ddd" }}>Challan Details</th>
                </tr>
              </thead>
              <tbody>
                {challans?.map((challan, index) => (
                  <tr key={index}>
                    <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}>
                      <b>{challan.challanNumber}</b>
                    </td>
                    <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}>
                      {challan.challanType} - ₹{challan.amount} - {challan.paymentStatus} - {challan.paymentDate}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </SummaryCard>

      <SummaryCard className="formContainer">
  <div className="formHeaderContainer">
    <h2 className="formHeading">Challan Heads</h2>
  </div>
  <div className="formInputContainer" style={{ display: "flex", justifyContent: "center" }}>
    <div style={{ width: "100%" }}>
      {challanHeads?.map((challan) => (
        <table key={challan.id} style={{ width: "100%", borderCollapse: "collapse", marginBottom: "20px" }}>
          <tbody>
            <tr>
              <td style={{ width: "25%", textAlign: "left", padding: "8px" }}>
                <b>Challan Number:</b>
              </td>
              <td style={{ width: "25%", padding: "8px" }}>{challan?.challanNumber}</td>
              <td style={{ width: "25%", textAlign: "left", padding: "8px" }}>
                <b>Challan Head:</b>
              </td>
              <td style={{ width: "25%", padding: "8px" }}>{challan?.headName}</td>
            </tr>
            <tr>
              <td style={{ textAlign: "left", padding: "8px" }}>
                <b>Receipt No:</b>
              </td>
              <td style={{ padding: "8px" }}>{challan?.receiptNumber}</td>
              <td style={{ textAlign: "left", padding: "8px" }}>
                <b>Challan Amount:</b>
              </td>
              <td style={{ padding: "8px" }}>{challan?.challanAmount}</td>
            </tr>
            <tr>
              <td style={{ textAlign: "left", padding: "8px" }}>
                <b>Paid Amount:</b>
              </td>
              <td style={{ padding: "8px" }}>{challan?.paidAmount}</td>
              <td style={{ textAlign: "left", padding: "8px" }}>
                <b>Transaction ID:</b>
              </td>
              <td style={{ padding: "8px" }}>{challan?.transactionID || "N/A"}</td>
            </tr>
          </tbody>
        </table>
      ))}
    </div>
  </div>
</SummaryCard>
    </div>
  );
};

export default MigratedSummary;
